import React, { forwardRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MDBBtn, MDBIcon, MDBModalFooter, MDBSpinner } from 'mdb-react-ui-kit'
import { useNavigate } from "react-router";
import { getMisc } from "../../../../apiclients/streamsapi_bridge";
import { getMultiSelectRequest, setMultiSelectValue } from "../../misc/MultiSelectRequest";
import PopupLoader from "../../PopupLoader";
import MultiSaveLimitAlert from "../../../../apiclients/MultiSaveLimitAlert";

const ChangeCallerId = forwardRef((props, ref) => {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [calleridList, setcalleridList] = useState([]);
    const [callerid, setcallerid] = useState(-1);
    const [error, setError] = useState("");
    const [warningMsg, setwarningMsg] = useState([]);
    const [showWarning, setShowWarning] = useState(false);
    const warningToggle = () => setShowWarning(!showWarning);
    const [saveWarningMessage, setsaveWarningMessage] = useState("");
    const [allEntriesDicard, setAllEntriesDicard] = useState(false);

    useEffect(() => {
        if (props.agentList && props.agentList.length > 0) {
            getCallerids();
        }
    }, [props.agentList]);
    async function getCallerids() {
        props.setIsloading(true);
        const tdata = await getMultiSelectRequest(1, props.agentList, props.moduleType);
        props.setIsloading(false);
        if (!tdata) {
            window.alert(`info with id  not found`);
            navigate("/");
        }
        console.log("Caller id for multi select ::::::::::::: " + JSON.stringify(tdata));
        //setServices(tdata.misc.services);
        setcalleridList(tdata?.result?.option_list ?? []);
        setwarningMsg(tdata?.result?.message ? [tdata?.result?.message] : []);

    }

    async function handleCallerIDChange(value) {
        props.setIsloading(true);
        const tdata = await setMultiSelectValue(1, value + "", props.agentList, props.moduleType);
        props.setIsloading(false);
        if (!tdata) {
            window.alert(`info with id  not found`);
            navigate("/");
        }
        const reponseMsg = tdata.display_Info ?? [];
        if (reponseMsg.length > 0) {
            setwarningMsg(reponseMsg);
        }
    }

    async function onsubmit(confirmFlag) {
        if (parseInt(callerid) === -1) {
            setError("Please select a Caller ID");
            return;
        }
        let tdata = null;
        props.setIsloading(true);
        if (confirmFlag) {
            tdata = await setMultiSelectValue(1, callerid + "", props.agentList, props.moduleType, 1, 1);
        } else {
            tdata = await setMultiSelectValue(1, callerid + "", props.agentList, props.moduleType, 1);
        }
        props.setIsloading(false);
        if (!tdata) {
            window.alert(`info with id  not found`);
            navigate("/");
        }
        if (tdata.status == "Failed") {
            localStorage.setItem(
                "user_create_f",
                "Something went wrong, Please try again after sometime"
            );
            props.onClose();
            window.location.href = "/userlanding";
        } else if (tdata.status == "failed") {
            if (tdata.exceededErrMsg) {
                setsaveWarningMessage(tdata.exceededErrMsg);
                if(tdata.all_grps_discarded) {
                    setAllEntriesDicard(true);
                }
                warningToggle();
                return;
            }
        } else {
            console.log("Caller id for multi select ::::::::::::: " + JSON.stringify(tdata));
            localStorage.setItem("s_message", tdata.message);

            if (props.locUser) {
                navigate("/locationsusers", {
                    state: { tab: props.locUser },
                });

            } else if (props.groupInfo) {
                navigate("/usersgroups", {
                    state: { tab: props.groupInfo },
                });

            } else if (props.groupUInfo) {
                navigate("/SelectedUserGroupSettings", {
                    state: { tab: "tab2", groupUInfo: props.groupUInfo },
                });
            } else if (props.usergroups) {
                navigate("/userlanding", {
                    state: { tab: "mgroups" },
                });
            } else if (props.userLoc) {
                navigate("/userlanding", {
                    state: { tab: "suser", tab2: "sloc" },
                });
            } else if (props.userAllgroups) {
                navigate("/userlanding", {
                    state: { tab: "suser", tab2: "sgroups" },
                });

            } else {
                navigate("/userlanding", {
                    state: { tab: "suser", tab2: "suser" },
                });
            }
            props.onClose();

            window.location.reload();
        }


    }

    return (
        <>
            <div style={{paddingBottom:125}}>
            <div >
                <strong className=" d-block">
                    {t("callerID")}
                </strong>
                <select
                    className="form-select form-control w-100 mt-2"
                    value={callerid}
                    onChange={(e) => {
                        setcallerid(e.target.value);
                        if (parseInt(e.target.value) === -1) {
                            setError("Please select a Caller ID");
                        } else {
                            setError("");
                            handleCallerIDChange(e.target.value);
                        }
                    }}
                >
                    <option value={-1}>-- Select Caller ID --</option>
                    {calleridList && calleridList.length > 0 && calleridList.map((callerid) => (
                        <option value={callerid.phnum}>{callerid.addl_info}</option>
                    ))}
                </select>
                {error && (
                    <p className="text-danger">{error}</p>
                )}
            </div>
            {warningMsg && warningMsg.map((meg) => (
                <div className="pt-2 phrecording">
                    {meg}
                </div>
            ))}
            </div>

                <div style={{ display: "none" }}>
                    <button ref={ref} onClick={(e) => {
                        e.preventDefault();
                        onsubmit();
                    }}>
                        {t("add")}</button>
                </div>

            {showWarning && (
                <>
                    <PopupLoader
                        title="Warning"
                        content={
                            <MultiSaveLimitAlert
                                saveWarningMessage={saveWarningMessage}
                                onClose={warningToggle}
                                handleClick={() => { if(allEntriesDicard) {warningToggle(); props.onClose();}onsubmit(1);}}
                            />
                        }
                        onShow={setShowWarning}
                        onClose={warningToggle}
                    />

                </>
            )}
        </>
    )
});

export default ChangeCallerId;
